import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'chamiliApostrofos';
const args = {};

export class ChamiliApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
